import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { api } from '../../api/client';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import './Admin.css';

export default function AdminForgotPassword() {
  const [email, setEmail] = useState('');
  const [sent, setSent] = useState(false);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await api('/api/admin/forgot-password', {
        method: 'POST',
        body: JSON.stringify({ email: email.trim() }),
      });
      setSent(true);
    } catch (err) {
      setError(err.message || 'Request failed');
    } finally {
      setLoading(false);
    }
  };

  if (sent) {
    return (
      <Box className="admin-login admin-login-vuexy">
        <Box className="admin-login-left" />
        <Box className="admin-login-right">
          <Typography variant="h5" className="admin-login-logo" sx={{ fontWeight: 600 }}>
            Gem Fashion Admin
          </Typography>
          <Box className="admin-login-form-wrap">
            <Typography variant="h6" sx={{ fontWeight: 600, mb: 2 }}>
              Check your email
            </Typography>
            <Typography color="text.secondary" sx={{ mb: 3 }}>
              If an account exists with that email, you will receive a link to reset your password.
            </Typography>
            <Button component={Link} to="/admin/login" variant="outlined" sx={{ textTransform: 'none' }}>
              Back to login
            </Button>
          </Box>
        </Box>
      </Box>
    );
  }

  return (
    <Box className="admin-login admin-login-vuexy">
      <Box className="admin-login-left" />
      <Box className="admin-login-right">
        <Typography variant="h5" className="admin-login-logo" sx={{ fontWeight: 600 }}>
          Gem Fashion Admin
        </Typography>
        <Box className="admin-login-form-wrap">
          <Typography variant="h4" sx={{ fontWeight: 600, mb: 0.5 }}>
            Forgot password?
          </Typography>
          <Typography color="text.secondary" sx={{ mb: 3 }}>
            Enter your email and we’ll send you a reset link.
          </Typography>
          <Box component="form" onSubmit={handleSubmit} noValidate className="admin-login-form">
            {error && (
              <Typography color="error" sx={{ mb: 2, fontSize: '0.875rem' }}>
                {error}
              </Typography>
            )}
            <TextField
              label="Email"
              type="email"
              fullWidth
              required
              autoComplete="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              sx={{ mb: 2 }}
              variant="outlined"
            />
            <Button
              type="submit"
              fullWidth
              variant="contained"
              size="large"
              disabled={loading}
              sx={{ mt: 1, py: 1.5, textTransform: 'none', fontWeight: 600 }}
            >
              {loading ? 'Sending…' : 'Send reset link'}
            </Button>
            <Button component={Link} to="/admin/login" fullWidth sx={{ mt: 2, textTransform: 'none' }}>
              Back to login
            </Button>
          </Box>
        </Box>
      </Box>
    </Box>
  );
}
